import { createAction, props } from '@ngrx/store';
import { ErrorModalModel, ErrorModalContent } from './error-modal.model';

export const SET_ERROR_MODAL = '[error modal] Set error modal';
export const SET_ERROR_MODAL_VISIBILITY = '[error modal] Set error modal visibility';
export const SET_ERROR_MESSAGE = '[error-message] Set error message';
export const SET_ERROR_MESSAGES_LIST = '[error-messages] Set error messages list';

export const setData = createAction(SET_ERROR_MODAL, props<{ data: ErrorModalModel }>());
export const setVisiblity = createAction(SET_ERROR_MODAL_VISIBILITY, props<{ isVisible: boolean }>());
export const setErrorMessage = createAction(SET_ERROR_MESSAGE, props<{ errorToShow: ErrorModalContent }>());
export const setErrorMessagesList = createAction(SET_ERROR_MESSAGES_LIST, props<{ defaultContent: ErrorModalContent[] }>());
